import type { MouseEvent, PropsWithChildren } from 'react'

import { Badge } from '@procurify/ui'

import { TabStyled } from './styles/TabStyled'

export interface ITabProps {
  active?: boolean
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
  count?: number | string
}

export const Tab = ({
  active,
  onClick,
  children,
  count,
}: PropsWithChildren<ITabProps>) => {
  return (
    <TabStyled
      role='tab'
      aria-selected={!!active}
      className={active ? 'active' : ''}
      onClick={onClick}
    >
      <>{children}</>
      {Number(count) > 0 && <Badge>{count}</Badge>}
    </TabStyled>
  )
}

Tab.displayName = 'Tab'
